import React, { ReactNode, MouseEvent } from 'react'
import styled, { css, RuleSet } from 'styled-components'
import { Noto_body2_m14, Noto_desc_b10 } from 'src/styles/fonts/NotoSansKrFonts'
import { xScrollStyle } from 'src/styles/mixin'
import { Roboto_num4_r12 } from 'src/styles/fonts/RobotoFonts'

type ChipsItemsType = 'big' | 'middle' | 'small' | 'little'

export interface ChipsListItemsProps {
  children: ReactNode
  size: ChipsItemsType
  active?: boolean
  onClickFn?: (event: MouseEvent<HTMLButtonElement>) => void
  color?: string
  style?: RuleSet<object>
}

export interface ChipsListProps {
  children: ReactNode
  style?: RuleSet<object>
}

const ChipsList = ({ children, style }: ChipsListProps) => {
  return <ChipsListWrap $style={style}>{children}</ChipsListWrap>
}

const ChipsItems = ({ size, children, onClickFn, active, color, style }: ChipsListItemsProps) => {
  return (
    <ChipsItemsWrap onClick={onClickFn} $size={size} $active={active} $color={color} $style={style}>
      {children}
    </ChipsItemsWrap>
  )
}
export const Chips = {
  List: ChipsList,
  Item: ChipsItems,
}

export const ChipsListStyle = (style?: RuleSet<object>) => css`
  display: flex;
  gap: 6px;
  width: 100%;
  ${style};
`
export const ChipsItemsBigStyle = css`
  height: 44px;
  padding: 10px 16px;
  ${Noto_body2_m14};
`
export const ChipsItemsMiddleStyle = css`
  height: 36px;
  padding: 6px 16px;
  ${Noto_body2_m14};
`
export const ChipsItemsSmallStyle = (color?: string) => css`
  height: 22px;
  padding: 3px 8px;
  ${Roboto_num4_r12};
  color: ${color || 'var(--black-50)'};
  border: 1px solid var(--black-10);
  cursor: default;
`
export const ChipsItemsLittleStyle = (color?: string) => css`
  height: 20px;
  padding: 2px 8px;
  ${Noto_desc_b10};
  color: ${color || 'var(--black-50)'};
  border: 1px solid var(--black-10);
  cursor: default;
`
export const ChipsActiveStyle = (color?: string) => css`
  color: ${color || 'var(--white)'};
  background: var(--black-90);
  border: 1px solid var(--black-90);
`
export const ChipsDefaultStyle = (color?: string) => css`
  color: ${color || 'var(--black-70)'};
  border: 1px solid var(--black-10);
  background: var(--white);
`

export const ChipsItemStyle = css`
  display: flex;
  cursor: pointer;
  width: fit-content;
  position: relative;
  border-radius: 100px;
  align-items: center;
  box-sizing: border-box;
`

const ChipsListWrap = styled.div<{ $style?: RuleSet<object> }>`
  ${xScrollStyle};
  ${(props) => ChipsListStyle(props.$style)};
`

const ChipsItemsWrap = styled.button<{
  $color?: string
  $bgColor?: string
  $size: ChipsItemsType
  $style?: RuleSet<object>
  $active?: boolean
  $borderColor?: string
}>`
  ${ChipsItemStyle};
  ${(props) =>
    props.$active &&
    css`
      ${ChipsActiveStyle(props.$color)}
    `}
  ${(props) =>
    !props.$active &&
    css`
      ${ChipsDefaultStyle(props.$color)};
    `}
  ${(props) =>
    props.$size === 'big' &&
    css`
      ${ChipsItemsBigStyle};
    `}

  ${(props) =>
    props.$size === 'middle' &&
    css`
      ${ChipsItemsMiddleStyle};
    `}
${(props) =>
    props.$size === 'small' &&
    css`
      ${ChipsItemsSmallStyle(props.$color)};
    `}
  ${(props) =>
    props.$size === 'little' &&
    css`
      ${ChipsItemsLittleStyle(props.$color)};
    `}
  ${(props) => props.$style};
`
